"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doctorSubstituteDocumentFileSchema = exports.getDoctorSubstituteDocumentUrlApiResponseSchema = exports.replaceDoctorSubstituteDocumentApiResponseSchema = exports.doctorSubstituteDocumentApiSchema = exports.ACCEPTED_DOCTOR_SUBSTITUTE_DOCUMENT_TYPES = exports.MAX_DOCTOR_SUBSTITUTE_DOCUMENT_SIZE = exports.doctorSubstituteDocumentTypeSchema = exports.doctorSubstituteDocumentTypes = void 0;
exports.isAcceptedDoctorSubstituteDocumentType = isAcceptedDoctorSubstituteDocumentType;
const zod_1 = require("zod");
/**
 * The two supporting documents a substitute must provide for the redesigned
 * contracts: the licence de remplacement (non-thésé only) and the attestation
 * d'assurance RCP (everyone).
 */
exports.doctorSubstituteDocumentTypes = ['licence', 'rcp'];
exports.doctorSubstituteDocumentTypeSchema = zod_1.z.enum(exports.doctorSubstituteDocumentTypes);
/** Max size of a supporting document upload (10 MB). */
exports.MAX_DOCTOR_SUBSTITUTE_DOCUMENT_SIZE = 10000000;
/** MIME types accepted for a supporting document. Declared type is trusted. */
exports.ACCEPTED_DOCTOR_SUBSTITUTE_DOCUMENT_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
];
/**
 * Whether an uploaded file's declared MIME type is accepted for a supporting
 * document.
 *
 * @param mimetype - Declared MIME type of the upload.
 * @returns `true` for PDF, JPEG and PNG.
 */
function isAcceptedDoctorSubstituteDocumentType(mimetype) {
    return exports.ACCEPTED_DOCTOR_SUBSTITUTE_DOCUMENT_TYPES.includes(mimetype);
}
/** Metadata of a stored supporting document, as exposed by the API. */
exports.doctorSubstituteDocumentApiSchema = zod_1.z
    .object({
    filename: zod_1.z.string(),
    uploadedAt: zod_1.z.coerce.date(),
})
    .nullable()
    .default(null);
exports.replaceDoctorSubstituteDocumentApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        type: exports.doctorSubstituteDocumentTypeSchema,
        filename: zod_1.z.string(),
        uploadedAt: zod_1.z.coerce.date(),
    }),
});
exports.getDoctorSubstituteDocumentUrlApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        url: zod_1.z.string(),
    }),
});
/**
 * Zod schema for an optional supporting-document file input (web forms).
 * Validates the declared MIME type and the size, accepts `undefined`.
 */
exports.doctorSubstituteDocumentFileSchema = zod_1.z
    .any()
    .optional()
    .refine((file) => {
    if (!file) {
        return true;
    }
    return isAcceptedDoctorSubstituteDocumentType(file.type);
}, 'form.errors.document-file-type')
    .refine((file) => {
    if (!file) {
        return true;
    }
    return file.size <= exports.MAX_DOCTOR_SUBSTITUTE_DOCUMENT_SIZE;
}, 'form.errors.document-max-size');
